import { useEffect } from 'react';

/**
 * The internet has reported that Cloudflare Web Analytics will inject a `$` at the bottom of the body.
 * While we have kept the tool disabled in our chain of tools, partner sites may still have it enabled,
 * and the unwanted node may still make it onto Premium pages.
 *
 * This function scans for text nodes matching exactly '$' and removes them.
 * @see https://github.com/remix-run/remix/discussions/10321
 */
const deleteUnwantedNodes = () => {
  const targetedNodes = Array.from(document.body.childNodes)
    .filter((node) => node.nodeType === Node.TEXT_NODE)
    .filter((node) => node.textContent?.trim() === '$');

  targetedNodes.forEach((node) => {
    node.remove();
  });
};

export const useBodyScrubber = () => {
  useEffect(() => {
    deleteUnwantedNodes();
  }, []);
};
